module.exports = __webpack_public_path__ + "static/Portrait-of-Axel-min-cf56219385f8682cdb0998b7d4c93d6f.jpg";